export default (tracker) => ({
  async linkClicked(referrer) {
    await tracker.track('Referral Link Clicked', {
      referrer,
    })
  },
})
